import { Cliente } from 'app/_models/cliente';
import { EventoTracking } from 'app/_models/evento-tracking';
import { TrackingCteNf } from 'app/_models/tracking-cte-nf';
import { TipoContainer } from 'app/_models/tipo-container';
import { TipoEventoTracking } from './tipoEventoTracking';
import { ImagemNF } from './imagemNF';
import { InfoSil } from './info-sil';

export class TrackingLista {
 	idPortoOrigem: number;
	idPortoDestino: number;
	idMunicOri: number;
	notaFiscal: any; //number - alterado pois na trackingDownload o campo é string
	num_cte: number;
	idMunicDes: number;
	idBooking: number;
	idUsuario: number;
	dataIni: number;
	dataFim: number;

	filtroGenerico :string;
	cnpjCli: string;
	nomeCli: string;
	cnpjEmb: string;
	nomeEmb: string;
	cnpjDes: string;
	nomeDes: string;
	numBooking: string;
	numContainer: string;
	viagemNavio: string;
	viagemNavioTrans: string;
	municColeta: string;
	portoOri: string;
	ufPortoOri: string;
	terminalOri: string;
	municEntrega: string;
	idMunicipioEntrega: number;
	portoDes: string;
	ufPortoDes: string;
	terminalDes: string;
	prevEntrega: Date;
	dataSaidaPortoDestino: Date;
	strPrevEntrega: string;
	strSaidaPortoDestino: string;
	statusBooking: string;

	portoTransbordo: string;
	ufPortoTransbordo: string;

	tipoEvento: string;
	statusEvento: string;
	dataRealizada: string;
	dataPrevista: string;

	canhoto: string;
	arquivo: string;
	serieNF: string;
	numRefCli: string;

	//booking: Booking;
	detalhes: EventoTracking[] = [];
	arquivosCTeNf: TrackingCteNf[] = [];
  tiposEventos: TipoEventoTracking[] = [];
  infosSil: InfoSil[] = [];
	idAgendEntrega: number;
	idAgendColeta: number;

	ieDes: string;
	cepDes: string;
	logradouroDes: string;
	numeroEndDes: string;
	bairroDes: string;
	complementoDes: string;
	idMunicipioDes: number;
	municipioDes: string;
	ufDes: string;
	contatoDes: string;
	dddDes: string;
	telefoneDes: string;

	tipoDeContainer : TipoContainer;

	categoriaContainer: string;
	tipoContainer: string;
	flagCargaOver: string;
	flagCargaPerigosa: string;
	flagCargaRefrigerada: string;
	idCategoriaContainer: number;
	modal: string;
	tamanhoContainer: number;
	realChegada: Date;
  strRealChegada: string;
  entregaRealizada: Date;
  strEntregaRealizada: string;

	PermiteAgendamentoColeta: boolean;
	permiteConsultaAgendamentoColeta: boolean;
	PendenteAgendamentoNavegando: boolean;
	PendenteAgendamentoDesembarcada: boolean;

  co2: number;
  indicEcoFrete: boolean;
  idViagreen: string;

  verNoMapa: boolean = false;
  CanhotosDisponiveis: ImagemNF[];
	loading: boolean;
	Destinatario: Cliente = new Cliente();

    private _cargaPerigosa: boolean = false;
    get cargaPerigosa(): boolean {
        this._cargaPerigosa = this.flagCargaPerigosa == 'S';
        return this._cargaPerigosa;
    }
    set cargaPerigosa(value: boolean) {
        this._cargaPerigosa = value;
        this.flagCargaPerigosa = this._cargaPerigosa ? 'S' : 'N';
    }

    private _cargaRefrigerada: boolean = false;
    get cargaRefrigerada(): boolean {
        if ((this.flagCargaRefrigerada == undefined) || (this.flagCargaRefrigerada == ""))
            return undefined;
        this._cargaRefrigerada = this.flagCargaRefrigerada == 'S';
        return this._cargaRefrigerada;
    }
    set cargaRefrigerada(value: boolean) {
        this._cargaRefrigerada = value;
        this.flagCargaRefrigerada = this._cargaRefrigerada ? 'S' : 'N';
    }

    private _cargaOver: boolean = false;
    get cargaOver(): boolean {
        if ((this.flagCargaOver == undefined) || (this.flagCargaOver == ""))
            return undefined;
        this._cargaOver = this.flagCargaOver == 'S';
        return this._cargaOver;
    }
    set cargaOver(value: boolean) {
        this._cargaOver = value;
        this.flagCargaOver = this._cargaOver ? 'S' : 'N';
    }
}
